import React from 'react'

import { Item } from 'components/common/Dropdown/styles'
import Text from 'components/common/Text'
import Tooltip2 from 'components/common/Tooltip2.0'

import { Wrapper } from './styles'
import useFullScreenToggle from './useFullScreenToggle'

const FullScreen = () => {
    const [isFullScreen, toggleFullScreen] = useFullScreenToggle()

    const icon = isFullScreen ? 'fullscreen-reverse' : 'fullscreen'

    const menu = {
        icon: `/assets/revamp/${icon}.svg`,
        alt: 'fullscreen-icon',
        copy: isFullScreen ? 'Exit fullscreen' : 'Enter fullscreen',
    }

    return (
        <Item.Area onClick={toggleFullScreen}>
            <Item.Icon>
                <img src={menu.icon} alt={menu.alt} />
            </Item.Icon>
            <Item.Copy>
                <Text level="3" bold={false}>
                    {menu.copy}
                </Text>
            </Item.Copy>
        </Item.Area>
    )
}

export default FullScreen
